module.exports = __webpack_public_path__ + "static/media/android-youtube-player_300px.29ca9fe6.png";